import Module, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import { TexasChipsView } from "./texas_chips_view";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import { TableHelp } from "../table/help/table_help";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import LoaclStorage from "../../../../manager/local_storage";
import LanguageManager from "../../../../manager/language_manager";
import GameUtil from "../../../../utility/game_util";
import TexasSound from "../texas_sound";

const {ccclass, property} = cc._decorator;

type callBack = (chipsNumb:number,autoBuy:Boolean)=>void;

export interface IChipsData{
    min:number;//最大
    max:number;//最小
    lockGold:number;//牌局中锁定的金币数
    bigBlind:number;//大盲注
    callFunc?:callBack;
    colseCallBack?:any;
    account_balance?:number;//账户余额
}

@ccclass
@moduleInit("TexasChips")
export  class TexasChips extends Module<TexasChipsView,null> {

    private chipsData:IChipsData;
    private totalGold:number = 0

    constructor(){
        super();
        this.layer = ViewLayer.Mid;
        this.viewType = TexasChipsView;
        this.windowPrefabResPath = 'package/texasholdem/module/chips/ChipsRoot';
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true
    }

    onInit(arg){
        super.onInit(arg);
        
        this.view.slider.node.on('slide',this.sliderCallBack,this);

        this.view.toggle.node.on('toggle',this.toggleCallBack,this);
    }

    onShow(args){
        let self = this
        self.chipsData = args;
        this.isSound = false;
        this.view.updateMoneyType(false)
        if (this.chipsData.account_balance != undefined) {
            this.totalGold = this.chipsData.account_balance;
            this.refreshChipsUI(args);
            return;
        }
        this.getSelfCurrencyData((currencyData: IUserCurrencyData) => {
            if (ModelData.instance.tableCommonData.isClubTable) {
                self.totalGold = currencyData.chipClub
            }else{
                self.totalGold = currencyData.chip + args.lockGold
            }
            
            self.refreshChipsUI(args);
        })
     }

    protected refreshChipsUI(args:any){
        this.chipsData.min = args.min || 0;
        this.chipsData.max = args.max || 0;
        this.chipsData.bigBlind = args.bigBlind || 0;
        this.chipsData.lockGold = args.lockGold || 0;
        super.onShow(args);
        this.view.isForbidOperator(this.totalGold < this.chipsData.min);
        this.raseValue = args.min;
        if( this.totalGold < args.min){
            //ModuleManager.instance.toastKey('server_error_-41');
            this.raseValue = this.totalGold;
        }
        this.dis = (this.chipsData.max-this.chipsData.min);
        this.updateUI();
    }

    protected onButtonClickName(name : string, customEventData){
        switch (name) {
            case 'ConfirmBtn':
                LoaclStorage.setNumber("CarryBFB",this.view.slider.progress)
                LoaclStorage.setNumber("AutoBuy", this.view.toggle.isChecked ? 1: 0)
                if (this.chipsData && this.chipsData.callFunc) {
                    this.chipsData.callFunc(this.raseValue || this.chipsData.min, this.view.toggle.isChecked);
                }
                ModuleManager.instance.destroyModule('TexasChips')
                break;
            case 'Closeui':
                if(this.chipsData && this.chipsData.colseCallBack){
                    this.chipsData.colseCallBack()
                }
                ModuleManager.instance.destroyModule('TexasChips')
                break;
            default:
                break;
        }
    }

    private setProgress(percent:number){
        percent = Math.min(percent,1);
        percent = Math.max(percent,0);
        this.view.slider.progress = percent;
        this.view.progressBar.progress = percent;
        this.view.sliderLab.string= TableHelp.addThousands(TableHelp.getRightMount( this.raseValue) )
    }


    private bidBlind:number
    private mindelta:number;
    private dis:number;
    private raseValue:number;
    sliderCallBack(slider:cc.Slider){

        this.disposeSliderMove(slider.progress)
    }

    oldbet = 0;
    //设置滑动,滑动最小值为一个大盲注
    private disposeSliderMove(val:number,isPlaySound:boolean = true){
        val = val >= 1 ? 1:val;
        if (this.dis == 0 || this.totalGold < this.chipsData.min) {
            this.setProgress(0);
            return;
        }
        let count = this.getBlindCount(val);
        let v = this.chipsData.min + this.bidBlind * count;
        this.view.isGraySlider(v > this.totalGold)

        if(v > this.totalGold){
            v = this.totalGold
            let _progress = (v - this.chipsData.min) / this.dis
            this.setProgress(_progress)
        }else{
            if (count > 0) {
                this.setProgress(this.mindelta * count);
            }
        }

        if (v<this.chipsData.min) {
            v=this.chipsData.min;
        }

        if (v>=this.chipsData.max) {
            v=this.chipsData.max;
        }
        
        this.raseValue = v

        this.view.sliderLab.string = GameUtil.currencyFormatting(v);

        if (isPlaySound && this.oldbet != v) {
            this.oldbet = v;
            this.playWeelSound();
        }
    } 

    private isSound = false;
    playWeelSound(){
        if (!this.isSound) {
            TexasSound.playGoldMove()
            this.isSound = true;
            this.scheduleOnce(()=>{
                this.isSound = false;
            },0.1);
        }
    }

    private getBlindCount(progress:number){
        let count = 0;
        while (progress <= 1) {
            if (progress <= this.mindelta*count) {
                break;
            }else{
                count++;
            }
        }
        return count;
    }


    private toggleCallBack(t:cc.Toggle){
    }

    private updateUI(){
        this.bidBlind = this.chipsData.bigBlind
        if (this.chipsData.max == 0 
            || this.bidBlind == 0) {

            return;
        }

        this.mindelta = 1 / ((this.chipsData.max-this.chipsData.min) / this.bidBlind )


        this.view.minLab.string= TableHelp.addThousands(this.chipsData.min);
        this.view.maxLab.string= TableHelp.addThousands(this.chipsData.max);

        this.view.totalGold.string = TableHelp.addThousands(TableHelp.getRightMount(this.totalGold) );

        let progress = LoaclStorage.getNumber("CarryBFB",0.5);
        this.view.slider.progress = <number>progress
        this.view.toggle.isChecked =  LoaclStorage.getNumber("AutoBuy", 0) == 1 ? true : false
        this.setProgress(this.view.slider.progress);
        this.disposeSliderMove(this.view.slider.progress,false)
    }

}
